// Formats time values into HHMM format (e.g. 09:30 -> "0930")
export const getFormattedTimeForGetCategoriesCall = (hours: number, minutes: number): string => {
  return `${String(hours).padStart(2, "0")}${String(minutes).padStart(2, "0")}`;
};
